import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  p {
    font-size: 20px;
    line-height: 26px;
    margin-left: 19px;

    @media (max-width: 1024px) {
      margin-top: 24px;
      font-size: 14px;
      line-height: 18px;
      margin-left: 16px;
    }
  }

  img {
    margin-top: 6px;
    width: 200px;
    height: 200px;
    object-fit: cover;
    flex-shrink: 0;

    @media (max-width: 1024px) {
      margin-left: 16px;
    }
  }
`;

const MAJacobs = (props) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <img src={require('assets/images/michael-jacobs.png')} alt="" />
      <p>
        Michael is a senior executive and legal professional with a diverse record of success
        improving multi-site operations through superior community engagement; human resources;
        labor and employee relations and legal experience.  Currently, he is a senior lecturer at
        the New York University, Robert F. Wagner Graduate School of Public Service and Adjunct
        Associate Professor at The City University of New York, School of Professional Studies.
        Michael was previously an adjunct faculty member at University of Maryland Global Campus
        (formerly, University of Maryland University College) and Howard University School of Law. 
      </p>
    </Wrapper>
  );
};

export default MAJacobs;
